import ContentFilterValues from "../model/ContentFilter";
import globalState from "../globalState";
import {Role} from "myfitworld-model";

const keys = [
  'healthIssues', 'suitableForHealthIssues', 'motorSkills', 'muscleGroups', 'secondaryMuscleGroups',
  'difficultyLevel', 'fitnessActivity', 'sports', 'equipment', 'goals', 'muscleRegime',
  'goodFor', 'mealTypes', 'counterProductiveFor', 'timePreparation', 'diet', 'micronutrient', 'category',
  'glycemicIndexRange', 'glycemicLoadRange','durationInWeeks' 
];

const clientSideContentFilter = (list: any[], chosenFilters: ContentFilterValues, orgId?: string, endpoint?: string) => {
  const { currentRole: userRole, currentUserId: userId, currentOrganization } = globalState.getRawState();
  const mfwOrgId = process.env.REACT_APP_MFW_ORGANIZATION_ID;
  const mergedResults = new Set<any>();
  const addToResults = (items: any[]) => {
    items.forEach(item => {
        mergedResults.add(item);
    });
  };

  if(chosenFilters.showPremium || chosenFilters.showPublic) {
    addToResults(list);
  }

  // MFW Originals - MYFITWORLD Content
  if (chosenFilters.showMFWOriginals) {
    const mfwItems = list.filter(_ => {
      if (userRole === Role.SuperAdmin) return _.organizationId === mfwOrgId;
      if (endpoint === 'exercises') {
        return _.organizationId === mfwOrgId || (_.authorId === userId && !_.orgContent);
      }
      return (_.organizationId === mfwOrgId && !_.premiumContent) || (_.authorId === userId && !_.orgContent);
    });
    addToResults(mfwItems);
  }

  // ORG Originals - Organization Content
  if (chosenFilters.showORGOriginals) {
    const orgItems = list.filter(_ =>
      (_.organizationId === currentOrganization?.id && _.orgContent) || _.authorId === userId
    );
    addToResults(orgItems);
  }

  // If no content filter selected, use default fallback
  const noMainFilter =
    !chosenFilters.showMFWOriginals &&
    !chosenFilters.showORGOriginals &&
    !chosenFilters.showPublic &&
    !chosenFilters.showPremium;
  if (noMainFilter) {
    const items = list.filter(_ => {
      return userRole === Role.SuperAdmin
        ? !_.premiumContent && _.organizationId === mfwOrgId
        : _.organizationId !== mfwOrgId && _.authorId === userId && !_.orgContent;
    });
    addToResults(items);
  }
  // Convert merged set to array
  let res = Array.from(mergedResults);

  // Archived
  res = res.filter(_ => chosenFilters.archived ? _.archived : !_.archived);

  // Locked content - My Marketplace Content
  if (chosenFilters.isLockedContentDisplayed) {
    res = res.filter(_ => _.isContentLocked === true && _.authorId === userId);
  }

  // My MFW Net
  if (chosenFilters.showMyMfwNet) {
    
    res = res.filter(_ => _.isPublic === true && _.authorId === userId);
  }

  // Attribute filters (e.g., sports, muscleGroups, etc.)
  if (!checkIsFilterEmpty(chosenFilters)) {
    for (const k of keys) {
      const key = k as keyof typeof chosenFilters;
      const filterVal = chosenFilters[key];
  
      if (Array.isArray(filterVal)) {
        res = res.filter(item => {
          const itemValue = item[key];
  
          if (Array.isArray(itemValue)) {
            return itemValue.some(v =>
              (filterVal as (string | number | boolean)[]).includes(v)
            );
          }
  
          return false;
        });
      }
    }
  }

  return res;
};

const checkIsFilterEmpty = (chosenFilters: ContentFilterValues) => {
  const ignoredKeys = [
    "archived", "showMFWOriginals", "showORGOriginals", "showPublic",
    "showPremium", "isLockedContentDisplayed", "showMyMfwNet"
  ];
  
  const validFilterKeys = [
    'sports', 'muscleGroups', 'secondaryMuscleGroups', 'motorSkills', 'muscleRegime',
    'healthIssues', 'suitableForHealthIssues', 'fitnessActivity', 'equipment', 'difficultyLevel',
    'goals', 'goodFor', 'mealTypes', 'counterProductiveFor', 'timePreparation', 'diet',
    'micronutrient', 'category', 'glycemicIndexRange', 'glycemicLoadRange', 'durationInWeeks'
  ] as const;
  
  type ValidFilterKey = typeof validFilterKeys[number];
  const isFilterEmpty = Object.keys(chosenFilters).every((key): boolean => {

    if (ignoredKeys.includes(key)) return true;
  
    const filterValue = chosenFilters[key as ValidFilterKey];
    return filterValue?.length === 0 || filterValue === "";
  });

  return isFilterEmpty;
  
}

export default clientSideContentFilter;
